import type { ScreenSchema } from './types';

/**
 * Schema for the email-question composite template.
 *
 * This template renders `screen-email` (left, plain mode) alongside
 * `screen-question` (right) on the same screen object. Because all content
 * lives on the same YAML screen object (no nested child screens), the question
 * text is included directly in the intro slot so the full context is narrated
 * in a single audio pass when the section activates.
 *
 * Audible content:
 *   - `intro`          — heading → text → instructions → question
 *   - `email-feedback` — post-submit email feedback; played by screen-email.vue
 *                        after the learner submits their answer
 *                        S3 key: `{screen.id}-email-feedback`
 *
 * Note: question feedback slots (correct / incorrect) are managed by the nested
 * screen-question component via the screen-question.schema.ts definition.
 */
const emailQuestionSchema: ScreenSchema = {
  template: 'email-question',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        { field: 'question' }
      ]
    },
    'email-feedback': {
      parts: [{ field: 'email.feedback' }]
    }
  }
};

export default emailQuestionSchema;
